import YChart from './Chart';

export { YChart };
export default YChart;
